const EXP_NONE_PORTFOLIO_JUMP_GOAL_CODES = new Set(['GOAL_JOB']);
const NO_LEVEL_CERT_TYPES = new Set(['LANG_NONE', 'LANG_TOPIK5']);

export const KOREAN_DEGREE_FOLLOW_UP_CODES = [
  'Q_Y_SINCE_GRAD',
  'Q_FIRST_D10',
];

const KOREAN_DEGREE_FOLLOW_UP_CODE_SET = new Set(
  KOREAN_DEGREE_FOLLOW_UP_CODES,
);

export const shouldHideRoleExploration = (answers = {}) =>
  answers.Q_OPTIONAL_CAREER_LINK !== 'CAREER_YES';

export const shouldHideKoreanDegreeFollowUp = (
  questionCode,
  answers = {},
) =>
  answers.Q_KR_DEGREE === 'KR_DEG_NO' &&
  KOREAN_DEGREE_FOLLOW_UP_CODE_SET.has(questionCode);

export const isQuestionAnswered = (question, answer) => {
  if (answer === null || answer === undefined) return false;
  if (question?.answerType === 'EXP_BLOCK_FLOW') {
    return answer?.complete === true;
  }
  if (Array.isArray(answer)) {
    if (question?.answerType === 'LANG_SCORE_PICKER') {
      return answer.some((row) => {
        if (!row?.certType) return false;
        return NO_LEVEL_CERT_TYPES.has(row.certType) || Boolean(row.level);
      });
    }
    return answer.length > 0;
  }
  if (typeof answer === 'object') {
    const { certType, level } = answer;
    if (!certType) return false;
    return NO_LEVEL_CERT_TYPES.has(certType) || Boolean(level);
  }
  return Boolean(answer);
};

const getNextVisibleStep = (questions, fromStep, isHiddenQuestion) => {
  let next = fromStep + 1;
  while (
    next <= questions.length &&
    isHiddenQuestion(questions[next - 1])
  ) {
    next += 1;
  }
  return next;
};

export const resolveNextQuestionStep = ({
  questions,
  fromStep,
  goalCode,
  isExpBlockNone,
  isHiddenQuestion = () => false,
}) => {
  if (
    isExpBlockNone &&
    EXP_NONE_PORTFOLIO_JUMP_GOAL_CODES.has(goalCode)
  ) {
    const portfolioIndex = questions.findIndex(
      (question) => question.questionCode === 'Q_PORTFOLIO_AWARD',
    );
    if (portfolioIndex !== -1) return portfolioIndex + 1;
  }

  return getNextVisibleStep(questions, fromStep, isHiddenQuestion);
};
